import axios from 'util/Api'

const BASE = '/asset-condition-voucher'

export const fetchSchema = () =>
  axios.get('/common/schema?model=AssetConditionVoucher').then((res) => res.data)

export const fetchVouchers = ({ limit, offset, acvNo, location }) => {
  const filters = []
  if (acvNo) filters.push(JSON.stringify({ type: 'String', field: 'acvNo', value: [acvNo] }))
  if (location) filters.push(JSON.stringify({ type: 'ObjectID', field: 'location', value: [location] }))
  return axios.get(BASE, {
    params: { limit, offset, sortField: 'createdAt', sortOrder: -1, filters: JSON.stringify(filters) }
  }).then((res) => res.data)
}

export const fetchVoucher = (id) => axios.get(`${BASE}/${id}`).then((res) => res.data)

export const createVoucher = (payload) => axios.post(BASE, payload).then((res) => res.data)

export const fetchReservedConditions = () =>
  axios.get(`${BASE}/reserved-conditions`).then((res) => res.data)

export const searchAssets = (q, { location, client } = {}) =>
  axios.get(`${BASE}/assets/search`, { params: { q, location, client } }).then((res) => res.data)

export const findAssetByScan = ({ qrId, assetCode, location, client }) =>
  axios.get(`${BASE}/assets/scan`, { params: { qrId, assetCode, location, client } }).then((res) => res.data)

export const uploadPhotos = (files) => {
  const form = new FormData()
  files.forEach((file) => form.append('files', file, file.name))
  return axios.post(`${BASE}/upload-photos`, form).then((res) => res.data)
}

export const errorMessage = (error, fallback = 'Something went wrong') => {
  const data = error && error.response && error.response.data
  if (!data) return fallback
  if (typeof data.message === 'string') return data.message
  // class-validator errors come back as an array of ValidationError objects
  if (Array.isArray(data.message) && data.message.length) {
    const first = data.message[0]
    const constraints = first && (first.constraints || (first.children && first.children[0] && first.children[0].constraints))
    if (constraints) return Object.values(constraints)[0]
  }
  return fallback
}
